import React from 'react';
// import { Field } from 'redux-form';
// import FieldError from '../../form/FieldError';
import InlineValue from '../InlineValue';
import Editor from './Editor';

const Boolean = {

  // Sub-components
  // OLDdesigner: (props) => {
  //   const {
  //     containerClassName,
  //     containerStyle,
  //     input,
  //     inputClassName,
  //     labelClassName,
  //     meta,
  //     onKeyDown,
  //     wrapperClassName,
  //     wrapperStyle,
  //   } = props;
  //   // console.log('Boolean designer: ', typeof input.value, input.value);
  //
  //   const designer = (
  //     <div className={wrapperClassName} style={wrapperStyle}>
  //       <label className={labelClassName}>Default Value</label>
  //       <div className={containerClassName} style={containerStyle}>
  //         <Field
  //           component="select"
  //           className={inputClassName || 'form-control'}
  //           onKeyDown={onKeyDown}
  //           name="boolean-designer"
  //           parse={(value) => (value === true) || (value === 'true')}
  //           value={false}
  //           {...input}
  //         >
  //           <option value>True</option>
  //           <option value={false}>False</option>
  //         </Field>
  //         {meta && <FieldError meta={meta} />}
  //       </div>
  //     </div>
  //   );
  //   return designer;
  // },

  designer: () => <div />,

  display: ({ toggleEditor, userMode, value }) => {
    // console.log('Boolean display: ', value);

    const clickToEdit = (userMode !== 'reader')
      ? <span className="clickToEdit">Click to edit</span>
      : null;

    let showVal;
    if ((value !== true) && (value !== false)) showVal = clickToEdit;
    else showVal = value ? 'True' : 'False';

    const displayValue = (
      <InlineValue toggleEditor={toggleEditor} userMode={userMode}>
        {showVal}
      </InlineValue>
    );
    return displayValue;
  },

  editor: Editor,
};

export default Boolean;



// WEBPACK FOOTER //
// ./src/components/types/Boolean/index.js